import { shortenAddress as customShortenAddress } from '@libs/helpers';
export const shortenAddress = customShortenAddress;
//# sourceMappingURL=walletAddress.js.map